import { Button } from '@cian/ui-kit/button';
import styles from './AdvancedFiltersModalFooter.css';
import { FC } from 'react';

interface IFooterProps {
  searchButtonText: string;
  isCounterRefreshing: boolean;
  onClearClick(): void;
  onShowClick(): void;
}

export const AdvancedFiltersModalFooter: FC<IFooterProps> = ({
  onClearClick,
  onShowClick,
  isCounterRefreshing,
  searchButtonText,
}) => {
  const buttons = (
    <>
      <Button size="XS" theme="fill_white_primary" onClick={onClearClick}>
        Сбросить фильтры
      </Button>
      <Button
        size="XS"
        theme="fill_primary"
        onClick={onShowClick}
        loading={isCounterRefreshing}
        data-testid="AdvancedFiltersApplyButton"
      >
        {searchButtonText}
      </Button>
    </>
  );

  return (
    <div
      className={styles['container']}
      data-testid="AdvancedFiltersModalFooter"
      data-name="AdvancedFiltersModalFooter"
    >
      {buttons}
    </div>
  );
};
